<button [matTooltip]="headerTooltip"
        [matTooltipShowDelay]="0"
        [matTooltipHideDelay]="0"
        [matTooltipPosition]="'above'"
        (click)="toggle()"
        [class.is-active]="isActive"
        mat-flat-button
        matRipple
        class="toggle-button"
        type="button">
    <mat-icon [svgIcon]="svgIcon"
              class="toggle-button-icon">{{ fontIcon }}</mat-icon>
    <span class="toggle-button-text">{{ headerText | translate }}</span>
    <mat-icon class="toggle-button-arrow">{{ expanded ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}</mat-icon>
</button>
<div class="item-container">
    <mat-list [@bodyExpansion]="accordionState"
              class="item-list">
        <ng-content select="ui-accordion-content-top"></ng-content>
        <ng-container *ngFor="let page of pages">
            <ng-container *ngTemplateOutlet="itemTemplate; context: { $implicit: page }"></ng-container>
        </ng-container>
        <ng-content select="ui-accordion-content-bottom"></ng-content>
    </mat-list>
</div>
